export default "/images/vendor/flag-icon-css/flags/1x1/gu.svg?35820090ead0219b998c5ca00528e556";